// extracted by mini-css-extract-plugin
export default {"menu-item":"EnbCsuUZ3AUsRuR","active":"valDgrq_5k5Fa2d","text":"sK6zDZTym1JoIcb","menu-main-item":"yx2BWfwBywyxkqU","icon":"SOTfPoxMj8S1Y72","transparent":"gpS5uqIAI1tTSEo"};